(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wedding-lead-form"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const formStyles = `
      :host {
        --app-embed-padding-x: 0;
        --app-embed-padding-y: 0;
        --inline-container-max-width: 100%;
        --container-max-w: 100%;
        --container-text-alignment: left;
        --forms-base-font-size: 14px;
        --forms-body-font: normal 400 14px Inter, sans-serif;
        --forms-heading-font: normal 700 22px Cormorant, Georgia, serif;
        --forms-accent-color: #e05a47;
        --forms-accent-color-hovered-modifier: #e05a471a;
        --link-text-color: #bd4434;
        --button-background-color: #e05a47;
        --button-text-color: #ffffff;
        --button-border-radius: 2px;
        --form-field-border-radius: 2px;
        --form-field-border: 0 0 0 1px rgba(26, 26, 26, .18);
        --form-field-border-focused: 0 0 0 2px #e05a47;
        --form-background-color: #ffffff;
        --container-background-color: transparent;
        --forms-padding-top: 0;
        --forms-padding-right: 0;
        --forms-padding-bottom: 0;
        --forms-padding-left: 0;
        --container-shadow: none;
      }
      [data-form-root="true"], [data-sizing="form-wrapper"], section[role="dialog"] {
        width: 100% !important;
        max-width: none !important;
        background: transparent !important;
        box-shadow: none !important;
      }
      section[role="dialog"] { display: block !important; padding: 0 !important; }
      form[data-testid="form"] { gap: 12px !important; }
      input:not([type="checkbox"]):not([type="radio"]), textarea, select {
        min-height: 52px !important;
        border-radius: 2px !important;
      }
      textarea { min-height: 88px !important; }
      fieldset { margin: 2px 0 0 !important; padding: 0 !important; }
      .wlf-form-optional {
        margin-left: 6px;
        color: #8b817b;
        font-family: Montserrat, sans-serif;
        font-size: 9px;
        font-weight: 700;
        letter-spacing: .08em;
        text-transform: uppercase;
      }
      fieldset > div {
        display: grid !important;
        grid-template-columns: repeat(2, minmax(0, 1fr));
        gap: 8px !important;
      }
      fieldset label {
        min-height: 44px;
        align-items: center;
        padding: 9px 10px;
        border: 1px solid rgba(26, 26, 26, .14);
        border-radius: 2px;
        background: #fffaf5;
      }
      button[type="submit"] {
        display: inline-flex !important;
        width: 100% !important;
        min-height: 56px !important;
        align-items: center !important;
        justify-content: center !important;
        padding-block: 0 !important;
        border-radius: 2px !important;
        background: #e05a47 !important;
        font-family: Montserrat, sans-serif !important;
        font-size: 13px !important;
        font-weight: 700 !important;
        letter-spacing: .09em !important;
        line-height: 1.2 !important;
        text-transform: uppercase !important;
      }
      button[type="submit"]:hover { background: #bd4434 !important; }
      @media (max-width: 420px) {
        fieldset > div { grid-template-columns: 1fr; }
        fieldset[name="custom#package_interest"] > div { grid-template-columns: repeat(2, minmax(0, 1fr)); }
      }
    `;

    const enhance = (root, attempt = 0) => {
      const embed = root.querySelector('shopify-forms-embed');
      const shadow = embed && embed.shadowRoot;
      if (!shadow) {
        if (attempt < 60) window.setTimeout(() => enhance(root, attempt + 1), 150);
        return;
      }

      if (!shadow.getElementById('wlf-form-styles')) {
        const style = document.createElement('style');
        style.id = 'wlf-form-styles';
        style.textContent = formStyles;
        shadow.appendChild(style);
      }

      const heading = shadow.querySelector('section[role="dialog"] h2');
      const header = heading && heading.closest('section');
      if (header) header.hidden = true;

      const optionalLabels = [
        shadow.querySelector('fieldset[name="custom#package_interest"] legend'),
        shadow.querySelector('fieldset[name="custom#what_would_help_today_"] legend'),
        shadow.querySelector('textarea[name="custom#have_any_other_questions_"] + label')
      ];

      optionalLabels.forEach((label) => {
        if (!label || label.querySelector('.wlf-form-optional')) return;
        const optional = document.createElement('span');
        optional.className = 'wlf-form-optional';
        optional.textContent = 'Optional';
        label.appendChild(optional);
      });
    };

    const boot = (scope = document) => {
      scope.querySelectorAll('[data-wedding-lead-form]').forEach((root) => enhance(root));
    };

    boot();
    document.addEventListener('shopify:section:load', (event) => boot(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
